export default [
    {
        path: '/prerequisite/payment-methods',

        name: 'Payment Methods',

        component: () => import('@/views/prerequisite/payment-methods'),
    },
];